import { cn } from "@/lib/utils"

const LABELS: Record<number, string> = {
  1990: "'90s",
  2000: "'00s",
  2010: "'10s",
  2020: "'20s",
}

export function decadeLabel(decade: number) {
  return LABELS[decade] ?? `${decade}s`
}

export function DecadeBadge({
  decade,
  className,
}: {
  decade: number | null
  className?: string
}) {
  if (!decade) return null
  return (
    <span className={cn("decade-badge", `decade-${decade}`, className)}>
      {decadeLabel(decade)}
    </span>
  )
}
